import { memo, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Snackbar from "@mui/material/Snackbar";
import Tooltip from "@mui/material/Tooltip";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import useTranslate from "../hooks/use-translate.hook";

const ChatClipboard = ( { email } ) => {
    const t = useTranslate();

    const [ emailCopied, setEmailCopied ] = useState( false );

    const copyEmail = async () => {
        await navigator.clipboard.writeText( email );
        setEmailCopied( true );
    };

    const closeAlertCopied = () => setEmailCopied( false );

    return (
        <>
            <Tooltip title={ t( "common:copy" ) }>
                <IconButton
                    onClick={ copyEmail }
                    size="small"
                >
                    <ContentCopyIcon fontSize="small" />
                </IconButton>
            </Tooltip>

            <Snackbar
                open={ emailCopied }
                autoHideDuration={ 2000 }
                onClose={ closeAlertCopied }
                message={ t( "common:copied" ) }
            />
        </>
    );
};

export default memo( ChatClipboard );